<!-- Funfacts -->
<div class="funfacts-area ptb-80">
  <div class="container">
    <div class="section-title">
      <h3 i18n="@@wipperozInNumbersTitle">Wipperoz in numbers</h3>
      <div class="bar"></div>
      <p i18n="@@wipperozInNumberDescription">
        More and more people offer their services and hire professionals wisely. Join our community that is constantly
        growing!
      </p>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-6 col-sm-3">
        <div class="funfact">
          <h3><span [countUp]="countUsers">00</span></h3>
          <p i18n="@@usersWorldwideTitle">Users Worldwide</p>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 col-6 col-sm-3">
        <div class="funfact">
          <h3><span [countUp]="countries.length">00</span></h3>
          <p i18n="@@wipperozCountriesTitle">Countries</p>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 col-6 col-sm-3">
        <div class="funfact">
          <h3><span [countUp]="uniqueProfessions.length">00</span></h3>
          <p i18n="@@professionsTitle">Professions</p>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 col-6 col-sm-3">
        <div class="funfact">
          <h3><span [countUp]="countLocations">00</span></h3>
          <p i18n="@@citiesTitle">Locations</p>
        </div>
      </div>
    </div>
    <app-wipperoz-have-question></app-wipperoz-have-question>
    <div class="map-bg">
      <img
        data-src="https://cdn.sanity.io/images/jizm7zxy/production/f541fd0423250b2926da38a036662e0a8528810c-910x443.png?fm=webp&q=90"
        alt="map"
        data-sizes="auto"
        class="lazyload"
      />
    </div>
  </div>
</div>
